import { createFileRoute } from "@tanstack/react-router";
import { CliAuthPage } from "@/components/cli-auth/cli-auth-page";

export const Route = createFileRoute("/_app/cli-auth/$sessionId/")({
  component: CliAuthPage,
  head: () => ({
    meta: [{ title: "CLI Authentication - Papier" }],
  }),
});
